import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import { AppUtils } from "../../models/common/appUtils";
import { useTranslation } from "react-i18next";
import { StrMeasureUnit } from "../../models/common/enums";
import RouteIcon from "@mui/icons-material/Route";
import Grid2 from "@mui/material/Unstable_Grid2";

interface WorkHourCardProps {
    amount: number;
    categoryId?: string;
    label?: string;
    unit?: StrMeasureUnit;
    bgColor?: string;
    content?: string;
    routeInfo?: {routeName: string; routeComment?: string};
}

export const WorkHourCard = ({
    amount,
    categoryId,
    label,
    unit,
    bgColor = "gray.light",
    content,
    routeInfo,
}: WorkHourCardProps) => {
    const { t } = useTranslation();

    return (
        <Card sx={{ mb: 2, bgcolor: bgColor }}>
            <CardContent sx={{
                "&:last-child": { pb: 2 } // override the default 24px to match top and bottom padding
            }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                    }}
                >
                    <Box
                        sx={{
                            textAlign: "left",
                        }}
                    >
                        <Typography
                            variant="h5"
                            color="primary.dark"
                        >
                            {label ?? t(`workTime.category.${categoryId}`)}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            textAlign: "right",
                            whiteSpace: "nowrap",
                        }}
                    >
                        <Typography variant="h5" color="primary.dark">
                            {unit
                                ? `${amount} ${unit}`
                                : AppUtils.getDurationStrByDurationMinShort(
                                    Math.abs(amount)
                                )}
                        </Typography>
                    </Box>
                </Box>
                {content ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            mt: 0.5,
                        }}
                    >
                        <Box
                            sx={{
                                textAlign: "left",
                            }}
                        >
                            <Typography
                                variant="subtitle2"
                                color="primary.dark"
                            >
                                {content}
                            </Typography>
                        </Box>
                    </Box>
                ) : null}
                {routeInfo ? (
                    <Grid2 container >
                        <Grid2 xs={12} display="flex" alignItems="center" mt={0.5}>
                            <RouteIcon fontSize="small" sx={{ color: "primary.dark" }}/>
                            <Typography sx={{ color: "primary.dark", fontSize: "0.8em", fontWeight: "bold" }}>
                                {routeInfo.routeName}
                            </Typography>
                        </Grid2>
                        {routeInfo.routeComment &&
                            <Typography sx={{ color: "primary.dark", fontSize: "0.8em", mt: 0.5 }}>
                                {routeInfo.routeComment}
                            </Typography>
                        }
                    </Grid2>
                ) : null}
            </CardContent>
        </Card>
    );
};
